import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { IGlobalSettings } from '@irb/irb-settings/irb-settings.model';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportExternalAccountsNoninventoriedGridLayoutService } from '@irb/irb-clients/import-external-accounts-securities-dialog/import-external-accounts-noninventoried.grid-layout.service';
import { ImportExternalAccountsUnrecognizedGridLayoutService } from '@irb/irb-clients/import-external-accounts-securities-dialog/import-external-accounts-unrecognized.grid-layout.service';
import { IrbModelsService } from '@irb/irb-models/irb-models.service';
import { ISecurityCustomCategories } from '@irb/irb-models/irb-models.model';
import { UtilityService } from '@irb-common/services/utility.service';
import { IExternalAccountsImportResponse } from '@irb/irb-clients/irb-clients.model';

@Component({ standalone: false,
  selector: 'irb-import-external-accounts-securities-dialog',
  templateUrl: './import-external-accounts-securities-dialog.component.html',
  styleUrls: ['./import-external-accounts-securities-dialog.component.scss']
})
export class ImportExternalAccountsSecuritiesDialogComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  globalSettings: IGlobalSettings;
  totalSelectCount: number = 0;
  securitiesCustomCategories: Array<any> = [];
  securityTypes: Array<any> = [
    {id:'GROUP', name:'Group'},
    {id:'OTHER', name:'Other'},
    {id:'SMA', name:'SMA'},
    {id:'EXTERNAL', name:'External'}
  ];

  parent_noninventoried: any = {
    enableDisableBtns: (() => { this.updateSelectCount(); }).bind(this),
    totalRecordsFromServer: 0,
    uniqueField: "securitySymbol",
    deselectedFromSelectAllRecords: [],
    securityTypes: this.securityTypes,
    securitiesCustomCategories: this.securitiesCustomCategories
  };
  grid_noninventoried: any;
  gridOptions_noninventoried: any;
  frameworkComponents_noninventoried: any;

  parent_unrecognized: any = {
    enableDisableBtns: (() => { this.updateSelectCount(); }).bind(this),
    totalRecordsFromServer: 0,
    uniqueField: "securitySymbol",
    deselectedFromSelectAllRecords: [],
    securityTypes: this.securityTypes,
    securitiesCustomCategories: this.securitiesCustomCategories
  };
  grid_unrecognized: any;
  gridOptions_unrecognized: any;
  frameworkComponents_unrecognized: any;
  
  constructor(
    public dialogRef: MatDialogRef<ImportExternalAccountsSecuritiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IExternalAccountsImportResponse,
    public as: AppService,
    private gls_noninventoried: ImportExternalAccountsNoninventoriedGridLayoutService,
    private gls_unrecognized: ImportExternalAccountsUnrecognizedGridLayoutService,    
    private iss: IrbSettingsService,
    private ms: IrbModelsService,
    private util: UtilityService
  ) {
    this.parent_noninventoried.totalRecordsFromServer = this.data.responseData.nonInventoriedList.length;
    this.parent_unrecognized.totalRecordsFromServer = this.data.responseData.unRecognizedList.length;

    this.ms.getSecuritiesCustomCategories().pipe(takeUntil(this.destroyed$)).subscribe((data: ISecurityCustomCategories) => {
      for (const item of data.items) {
        this.securitiesCustomCategories.push({ value: String(item.custCatId), name: item.custCatName });
      }

      this.securitiesCustomCategories = this.util.sortByKey(this.securitiesCustomCategories, "name");
      this.parent_noninventoried.securitiesCustomCategories = this.securitiesCustomCategories;
      this.parent_unrecognized.securitiesCustomCategories = this.securitiesCustomCategories;

      this.gridOptions_noninventoried = {
        columnDefs: this.gls_noninventoried.getColumnDefs(this.parent_noninventoried),
        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities found.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple'
      };
      
      this.frameworkComponents_noninventoried = this.gls_noninventoried.getFrameworkComponents();
  
      this.gridOptions_unrecognized = {
        columnDefs: this.gls_unrecognized.getColumnDefs(this.parent_unrecognized),
        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities found.</span>",
        context: { componentParent: this },
        rowSelection: 'multiple'
      };
      
      this.frameworkComponents_unrecognized = this.gls_unrecognized.getFrameworkComponents();
    });
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  onNoninventoriedGridReady(params: any) {
    this.grid_noninventoried = params;
    this.setCCColumnHeader(this.grid_noninventoried);
  }

  onUnRecognizedGridReady(params: any) {
    this.grid_unrecognized = params;
    this.setCCColumnHeader(this.grid_unrecognized);
  }

  setCCColumnHeader(g: any) {
    const f = () => {
      if (this.globalSettings.securityCustAttrAbbr) {
        g.api.getColumnDef("custCategoryCol").headerName = this.globalSettings.securityCustAttrAbbr;
        g.api.refreshHeader();
      }
    };

    if(!this.globalSettings) {
      this.iss.getGlobalSettings().subscribe((data) => {
        this.globalSettings = data as IGlobalSettings;
        f();
      });
    } else {
      f();
    }
  }

  updateSelectCount() {
    this.totalSelectCount = (this.grid_noninventoried && this.grid_noninventoried.api && this.grid_noninventoried.api.getSelectedRows) ? this.grid_noninventoried.api.getSelectedRows().length : 0;
    this.totalSelectCount += (this.grid_unrecognized && this.grid_unrecognized.api && this.grid_unrecognized.api.getSelectedRows) ? this.grid_unrecognized.api.getSelectedRows().length : 0;
  }

  completeImport() {
    this.data.responseData.nonInventoriedList = (this.grid_noninventoried && this.grid_noninventoried.api && this.grid_noninventoried.api.getSelectedRows) ? this.grid_noninventoried.api.getSelectedRows() : [];
    this.data.responseData.unRecognizedList = (this.grid_unrecognized && this.grid_unrecognized.api && this.grid_unrecognized.api.getSelectedRows) ? this.grid_unrecognized.api.getSelectedRows() : [];
    this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_READY, this.data);
    this.close();
  }

  updateRow(params: any) {
    //const n = this.grid_unrecognized.api.getDisplayedRowAtIndex(rowIndex);
    this.grid_unrecognized.api.redrawRows({ rowNodes: [params.node] });
  }
}
